import React from "react";
import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation } from "../../utils/useful";

// var moment = require('jalali-moment');
let moment = require('moment-timezone');

class DateInput extends React.Component {

    state = {
        // title: moment(),
        isOpen: false,
        startOfMonth: '',
        endOfMonth: '',
        week: ['mon', 'tu', 'we', 'th', 'fr', 'sa', 'su'],
        days: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        month: { startDay: 0, daysCount: 30 },
        monthFromNow: 0,
        today: '',
        showYearPicker: false,
        // currentTime
    }

    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }


    componentWillMount() {
        // console.log(moment().day())
        // let now = new Date().getTime() 
        // this.setState({ title: noew })

        this.setState({ title: this.props.data, today: new Date().getTime() })
        // // this.props.changeValue(this.props.header.key, day.start)

        // console.log(new Date().getTime())
        // this.setMonth(0)
        if (this.props.data) {
            this.setMonth(0, this.props.data)

        } else {
            this.setMonth(0)
        }
    }

    componentDidUpdate(prevProps) {

        if (prevProps.data != this.props.data) {

            //     console.log('Update')
            // console.log(this.props.data)
            this.setMonth(0, this.props.data)
            this.setState({ title: this.props.data })
        }
    }

    changeMonth(number) {

        this.setMonth(this.state.monthFromNow + number)
        this.setState({ monthFromNow: this.state.monthFromNow + number })
    }

    changeYear(number) {
        // Jump a full year (12 months) forward or backward
        this.changeMonth(number * 12)
    }

    setMonth(fromNow,startDate) {

        // this.setState({month:{}},()=>{


        let now = new Date();
        let days = []

        let start = moment(now).tz('Asia/Singapore').add(fromNow, 'month').startOf('month')

        if (startDate) {
            start = moment(startDate).tz('Asia/Singapore').add(fromNow, 'month').startOf('month')
        }

        // let end = moment(now).add(fromNow, 'month').endOf('month')
        // let count = 0

        for (let i = 0; i < moment(now).tz('Asia/Singapore').add(fromNow, 'month').daysInMonth(); i++) {

            days.push({ start: moment(start).tz('Asia/Singapore').add(i, 'day').startOf('day').valueOf(), end: moment(start).tz('Asia/Singapore').add(i, 'day').endOf('day').valueOf() })
            // count++
        }
        // console.log(days)

        // this.setState({ isOpen: false }, () => {
        this.setState({ month: { title: moment(start).tz('Asia/Singapore').format('YYYY-MMMM'), startDay: start.day(), days: days } })
        // })
        // console.log(start.unix())
        // console.log(end.day())
        // })
    }

    setDay(day) {
        let startOrEnd = this.props.startOrEnd ? this.props.startOrEnd : "start"
        if(!this.props.startOrEnd && this.props.header.information?.startOrEnd){
            startOrEnd = this.props.header.information.startOrEnd
        }
        this.setState({ title: day[startOrEnd] })
        // console.log()
        this.props.changeValue(this.props.header.key, day[startOrEnd], this.props.extra)

    }

    setYear(year) {
        // Set date to January 1st of the selected year
        const yearStart = moment().tz('Asia/Singapore').year(year).month(0).date(1).startOf('day')
        this.setState({ title: yearStart.valueOf() })
        this.props.changeValue(this.props.header.key, yearStart.valueOf(), this.props.extra)
        this.setState({ isOpen: false, showYearPicker: false })
    }

    showDays() {

        // let day = 1
        let week = []
        let weeks = []
        let days = []
        let startDay = this.state.month.startDay

        // let firstWeek = true
        let count = 0
        // console.log('startDay::',startDay)
        startDay = startDay === 0 ? 7 : startDay
        for (let i = 0; i < startDay - 1; i++) {
            days.push(null)
        }

        days = [...days, ...this.state.month.days]

        for (let i = 0; i < days.length; i++) {
            // console.log("HERE")
            count++
            week.push(days[i])
            if (count == 7 || i == days.length - 1) {
                weeks.push(week)
                count = 0
                week = []
            }
        }

        // console.log(weeks)

        let lastWeekLenght = weeks[weeks.length - 1].length
        if (lastWeekLenght < 7) {
            for (let i = 0; i < 7 - lastWeekLenght; i++) {
                // console.log("HERE")
                weeks[weeks.length - 1].push(null)
            }
        }


        // console.log(weeks)
        // console.log(weeks)
        count = 0

        return weeks.map((week, index) => {

            // if(index ==  )
            return (
                <div key={index} className="d-flex text-center pl-2 pr-2 w-100 " style={{ justifyContent: 'space-between' }}>
                    {week.map((day, index1) => {
                        // console.log(count)
                        if (day == null) {
                            return (
                                <div key={index1} style={{ width: '100%', padding: 10, width: 35 }}>
                                </div>
                            )
                        } else {
                            count++

                            let isToday = (this.state.today >= day.start && this.state.today <= day.end) ? true : false
                            let selectedDay = (this.state.title >= day.start && this.state.title <= day.end) ? true : false

                            let available = true

                            if (this.props.endDate && day.start > this.props.endDate) {
                                available = false
                            }

                            if (this.props.startDate && day.end < this.props.startDate) {
                                available = false
                            }
                            // console.log(this.props.startDate)
                            // if()
                            return (
                                <div onClick={() => { if (available) this.setDay(day) }} key={index1} style={{ cursor: 'pointer', width: '100%', backgroundColor: selectedDay ? '#007aff' : '#fcfcfc', padding: 0, borderRadius: 40, width: 35, height: 35, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                                    <div style={{ backgroundColor: isToday ? '#007aff20' : 'transparent', borderRadius: 40, padding: 0, minWidth: 25, height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <span style={{ color: available ? (selectedDay ? '#fff' : '#345') : '#abc', fontSize: 12 }}>{count}</span>
                                    </div>
                                </div>
                            )
                        }
                    })
                    }

                </div>
            )
        })




    }


    componentWillUnmount() {
        document.removeEventListener('mousedown', this.closeBox);
        window.removeEventListener('scroll', this.getPosition);

    }

    openBox() {
        console.log("OPENBOX")
        document.addEventListener('mousedown', this.closeBox);
        window.addEventListener('scroll', this.getPosition, true);
        this.getPosition()
        const onlyYear = this.props.header?.information?.onlyYear
        this.setState({ isOpen: true, showYearPicker: onlyYear || false })
    }


    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);

            if (this.refs.icon)
                this.refs.icon.classList.toggle("rotate-180")

        }
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    getPosition = () => {
        // console.log("getPosition")
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left })
    }



    render() {
        let info = this.props.header.information
        const onlyYear = info?.onlyYear

        // console.log(this.state.title)

        return (
            <div className='mt-0 w-100 h-100' >
                {/* <label className={'mb-2 mr-1 ml-1 ' + (info.required ? 'required' : '')} style={{ marginBottom: 3, fontSize: 12, marginTop: 5, color: '#999' }}>{info.label}</label> */}
                {/* <input disabled={info.disabled} onChange={e => { this.props.changeValue(this.props.header.key, e.target.value) }} className='form-control' defaultValue={this.props.title} placeholder={info.placeHolder} style={{ backgroundColor: '#f7f7f7', color: '#3b3a40' }} /> */}
                <div className='position-relative' ref={ref => this.setWrapperRef(ref)}>
                    <div onClick={() => !info.disabled ?this.openBox():''} disabled={info.disabled} onChange={e => { this.props.changeValue(this.props.header.key, e.target.value) }} className='' defaultValue={this.props.data} placeholder={info.placeHolder} style={{ height: 25, color: '#222', display: 'flex', alignItems: 'center' }} >
                        {this.state.title && (<p className="text-small">{this.state.title ? moment(this.state.title).tz('Asia/Singapore').format(onlyYear ? 'YYYY' : 'YYYY - MMM - DD') : ''}</p>)}
                        {!this.state.title && (<p style={{ opacity: 0.3 }}>{checkTranslation(info.placeholder)}</p>)}
                    </div>

                    {this.state.isOpen && (
                        <div style={{ position: 'fixed', top: this.state.top, backgroundColor: '#fff', borderRadius: 5, width: '270px', zIndex: 10, boxShadow: '0px 0px 30px rgba(0,0,0,0.1)', padding: 10 }}>
                            {onlyYear ? (
                                // Only show year picker
                                <div
                                    className="mb-1"
                                    style={{
                                        maxHeight: 400,
                                        overflowY: 'auto',
                                        borderRadius: 8,
                                        border: '1px solid #eee',
                                        padding: '6px 4px',
                                        background: '#fafafa',
                                    }}
                                >
                                    {(() => {
                                        const hasFuture = this.props.header?.information?.hasFuture
                                        const info = this.props.header?.information || {}
                                        const todayMoment = moment(this.state.today).tz('Asia/Singapore')
                                        const currentYear = todayMoment.year()
                                        const startYear = typeof info.minYear === 'number' ? info.minYear : currentYear - 110
                                        const endYear = typeof info.maxYear === 'number'
                                            ? info.maxYear
                                            : (hasFuture ? currentYear + 50 : currentYear)

                                        // Determine selected year from current title (selected date) if available,
                                        // otherwise fall back to today
                                        const baseMoment = this.state.title
                                            ? moment(this.state.title).tz('Asia/Singapore')
                                            : todayMoment
                                        const selectedYear = baseMoment.year()

                                        const years = []
                                        for (let y = endYear; y >= startYear; y--) {
                                            years.push(y)
                                        }
                                        return (
                                            <div className="d-flex flex-wrap justify-content-center">
                                                {years.map((year) => {
                                                    const isSelected = year === selectedYear
                                                    return (
                                                        <button
                                                            key={year}
                                                            type="button"
                                                            className="m-1"
                                                            style={{
                                                                minWidth: 56,
                                                                padding: '4px 10px',
                                                                borderRadius: 999,
                                                                border: isSelected ? '2px solid #10453d' : '1px solid #d1d5db',
                                                                background: isSelected
                                                                    ? 'linear-gradient(135deg, #10453d 0%, #146a5d 100%)'
                                                                    : '#ffffff',
                                                                color: isSelected ? '#ffffff' : '#374151',
                                                                fontSize: 12,
                                                                fontWeight: isSelected ? 600 : 500,
                                                                textAlign: 'center',
                                                                cursor: 'pointer',
                                                                boxShadow: isSelected
                                                                    ? '0 2px 6px rgba(0,0,0,0.15)'
                                                                    : '0 1px 3px rgba(0,0,0,0.08)',
                                                                transition: 'all 0.15s ease-in-out',
                                                            }}
                                                            onClick={() => {
                                                                this.setYear(year)
                                                            }}
                                                        >
                                                            {year}
                                                        </button>
                                                    )
                                                })}
                                            </div>
                                        )
                                    })()}
                                </div>
                            ) : (
                                // Normal date picker with month/day navigation
                                <>
                                    <div className="d-flex p-2" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div className="d-flex align-items-center">
                                            {/* Previous year */}
                                            <img
                                                onClick={() => this.changeYear(-1)}
                                                src="/images/nexts.png"
                                                className="reverse"
                                                style={{ opacity: 0.6, marginRight: 6 }}
                                                height="12px"
                                                alt="prev-year"
                                            />
                                            {/* Previous month */}
                                            <img
                                                onClick={() => this.changeMonth(-1)}
                                                src="/images/nexts.png"
                                                className="reverse"
                                                height="14px"
                                                alt="prev-month"
                                            />
                                        </div>
                                        <p
                                            style={{ margin: 0, cursor: 'pointer' }}
                                            onClick={() => this.setState({ showYearPicker: !this.state.showYearPicker })}
                                        >
                                            {this.state.month.title}
                                        </p>
                                        <div className="d-flex align-items-center">
                                            {/* Next month */}
                                            <img
                                                onClick={() => this.changeMonth(1)}
                                                src="/images/nexts.png"
                                                height="14px"
                                                alt="next-month"
                                            />
                                            {/* Next year */}
                                            <img
                                                onClick={() => this.changeYear(1)}
                                                src="/images/nexts.png"
                                                style={{ opacity: 0.6, marginLeft: 6 }}
                                                height="12px"
                                                alt="next-year"
                                            />
                                        </div>
                                    </div>

                                    {this.state.showYearPicker && (
                                        <div
                                            className="mt-2 mb-1"
                                            style={{
                                                maxHeight: 200,
                                                overflowY: 'auto',
                                                borderRadius: 8,
                                                border: '1px solid #eee',
                                                padding: '6px 4px',
                                                background: '#fafafa',
                                            }}
                                        >
                                            {(() => {
                                                const hasFuture = this.props.header?.information?.hasFuture
                                                const info = this.props.header?.information || {}
                                                const todayMoment = moment(this.state.today).tz('Asia/Singapore')
                                                const currentYear = todayMoment.year()
                                                const startYear = typeof info.minYear === 'number' ? info.minYear : currentYear - 110
                                                const endYear = typeof info.maxYear === 'number'
                                                    ? info.maxYear
                                                    : (hasFuture ? currentYear + 50 : currentYear)

                                                // Determine selected year from current title (selected date) if available,
                                                // otherwise fall back to today
                                                const baseMoment = this.state.title
                                                    ? moment(this.state.title).tz('Asia/Singapore')
                                                    : todayMoment
                                                const selectedYear = baseMoment.year()

                                                const years = []
                                                for (let y = endYear; y >= startYear; y--) {
                                                    years.push(y)
                                                }
                                                return (
                                                    <div className="d-flex flex-wrap justify-content-center">
                                                        {years.map((year) => {
                                                            const isSelected = year === selectedYear
                                                            return (
                                                                <button
                                                                    key={year}
                                                                    type="button"
                                                                    className="m-1"
                                                                    style={{
                                                                        minWidth: 56,
                                                                        padding: '4px 10px',
                                                                        borderRadius: 999,
                                                                        border: isSelected ? '2px solid #10453d' : '1px solid #d1d5db',
                                                                        background: isSelected
                                                                            ? 'linear-gradient(135deg, #10453d 0%, #146a5d 100%)'
                                                                            : '#ffffff',
                                                                        color: isSelected ? '#ffffff' : '#374151',
                                                                        fontSize: 12,
                                                                        fontWeight: isSelected ? 600 : 500,
                                                                        textAlign: 'center',
                                                                        cursor: 'pointer',
                                                                        boxShadow: isSelected
                                                                            ? '0 2px 6px rgba(0,0,0,0.15)'
                                                                            : '0 1px 3px rgba(0,0,0,0.08)',
                                                                        transition: 'all 0.15s ease-in-out',
                                                                    }}
                                                                    onClick={() => {
                                                                        const yearDiff = year - selectedYear
                                                                        const fromNow = this.state.monthFromNow + yearDiff * 12
                                                                        this.setMonth(fromNow)
                                                                        this.setState({ monthFromNow: fromNow, showYearPicker: false })
                                                                    }}
                                                                >
                                                                    {year}
                                                                </button>
                                                            )
                                                        })}
                                                    </div>
                                                )
                                            })()}
                                        </div>
                                    )}

                                    <div className="d-flex p-2  text-center w-100" style={{ justifyContent: 'space-between' }}>
                                        {this.state.week.map((prop, index) => {
                                            return (
                                                <div className={'w-100'} style={{ width: 35, }}>
                                                    <p style={{ color: '#789', fontSize: 12 }}>{prop}</p>
                                                </div>
                                            )
                                        })}
                                    </div>

                                    {this.showDays()}
                                </>
                            )}

                        </div>
                    )}

                </div>

            </div>
        );
    }
}

export default DateInput;
